const constants = require('../../../utils/domain/constants.js');
const stringUtil = require('../../../utils/string/stringUtil.js');
const dateUtil = require('../../../utils/dateUtil/dateUtil.js');
const staffUtility = require('../../../utils/domain/staff/staffUtility.js');
const commonUtility = require('../../../utils/domain/commonUtility.js');

module.exports.getSnoozeDetailsForCategory = function (menu, snoozes, menuCategory)
{
    const overview = {};

    overview.noOfItemsSnoozed = 0;
    overview.noOfModifiersSnoozed = 0;

    menuCategory.items.forEach(categoryItem =>
    {
        const categoryItemSnooze = this.getSnoozedItem(menu.id, snoozes, categoryItem.id, constants.SnoozeItemTypes.categoryItem);
        if (this.isSnoozed(categoryItemSnooze))
        {
            overview.noOfItemsSnoozed = overview.noOfItemsSnoozed + 1;
        }
        categoryItem.modifierMembers.forEach(modifierMember =>
        {
            overview.noOfModifiersSnoozed = overview.noOfModifiersSnoozed + getTotalSnoozedModifierItems(menu, snoozes, modifierMember.modifierId);
        })
    })

    return overview;
}

module.exports.getSnoozeOverviewInCategoryItem = function (menu, snoozes, menuCategoryItem)
{
    var categoryItemSnooze = this.getSnoozedItem(menu.id, snoozes, menuCategoryItem.id, constants.SnoozeItemTypes.categoryItem);

    var overview = {};
    overview.isSnoozed = this.isSnoozed(categoryItemSnooze);
    overview.noOfModifiersSnoozed = 0;

    menuCategoryItem.modifierMembers.forEach(modifierMember =>
    {
        overview.noOfModifiersSnoozed = overview.noOfModifiersSnoozed + getTotalSnoozedModifierItems(menu, snoozes, modifierMember.modifierId);
    })

    return overview;
}

module.exports.getSnoozeOverviewInModifierItem = function (menu, snoozes, menuModifierItem)
{
    var modifierItemSnooze = this.getSnoozedItem(menu.id, snoozes, menuModifierItem.id, constants.SnoozeItemTypes.modifierItem);

    var overview = {};
    overview.isSnoozed = this.isSnoozed(modifierItemSnooze);
    overview.noOfModifiersSnoozed = 0;

    menuModifierItem.modifierMembers.forEach(modifierMember =>
    {
        overview.noOfModifiersSnoozed = overview.noOfModifiersSnoozed + getTotalSnoozedModifierItems(menu, snoozes, modifierMember.modifierId);
    })

    return overview;
}

module.exports.getSnoozedItem = function (menuId, snoozes, itemId, itemType)
{
    const snoozedItem = snoozes[itemId];
    if (snoozedItem?.menus.includes(menuId) && snoozedItem.secondaryId === itemType)
    {
        return snoozedItem;
    }
}

module.exports.isSnoozed = function (snooze)
{
    return snooze != null && snooze.isSnoozed && (snooze.expiry === "-1" || dateUtil.isBefore(dateUtil.getNow(), snooze.expiry));
}

module.exports.isItemSnoozed = function (menuId, snoozes, itemId, itemType)
{
    return this.isSnoozed(this.getSnoozedItem(menuId, snoozes, itemId, itemType));
}

module.exports.createBlankSnooze = function (menu)
{
    const snooze = {
        menus: [menu.id],
        venueCodes: [],
        dispatchTypes: [],
        isSnoozed: false,
        expiry: "",
        expiryCaption: "",
        type: constants.SnoozeTypes.menuItem,
        primaryId: "",
        secondaryId: "",
        operator: staffUtility.getLoginStaffCompleteName(),
        isExisting: false,
        isUpdated: true
    };
    return snooze;
}

function getTotalSnoozedModifierItems(menu, snoozes, modifierId)
{
    const modifier = menu.modifiers.find(m => stringUtil.areStringSame(m.id, modifierId));
    if (modifier == null)
        return 0;

    var count = 0;
    modifier.items.forEach(modifierItem =>
    {
        const modifierItemSnooze = module.exports.getSnoozedItem(menu.id, snoozes, modifierItem.id, constants.SnoozeItemTypes.modifierItem);

        if (module.exports.isSnoozed(modifierItemSnooze))
            count = count + 1;

        modifierItem.modifierMembers.forEach(modifierMember =>
        {
            count = count + getTotalSnoozedModifierItems(menu, snoozes, modifierMember.modifierId);
        })
    });

    return count;
}

module.exports.getSnoozeDescription = function (menu, snooze)
{
    var description = {};
    description.type = "";
    description.caption = "";


    if (stringUtil.areStringSame(snooze.secondaryId, constants.SnoozeItemTypes.categoryItem))
    {
        description.type = "Menu Item";
        var menuCategory = null;
        var menuCategoryItem = null;

        menu.categories.forEach(category =>
        {
            category.items.forEach(categoryItem =>
            {
                if (stringUtil.areStringSame(categoryItem.id, snooze.primaryId))
                {
                    menuCategory = category;
                    menuCategoryItem = categoryItem;
                }
            })
        });

        if (menuCategoryItem != null)
        {
            description.caption = `${menuCategory.caption} / ${menuCategoryItem.caption}`;
        }
        else
        {
            description.caption = "Unknown";
        }

    }
    else
    {
        description.type = "Modifier";
        var menuModifier = null;
        var menuModifierItem = null;

        menu.modifiers.forEach(modifier =>
        {
            modifier.items.forEach(modifierItem =>
            {
                if (stringUtil.areStringSame(modifierItem.id, snooze.primaryId))
                {
                    menuModifier = modifier;
                    menuModifierItem = modifierItem;
                }
            })
        });

        if (menuModifierItem != null)
        {
            description.caption = `${menuModifier.caption} / ${menuModifierItem.caption}`;
        }
        else
        {
            description.caption = "Unknown";
        }
    }

    return description;
}

